<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre9">Dramatis personae</h3>
<p class="calibre5"></p>
<table cellpadding="5" cellspacing="0" class="true" summary="Personen">
<tbody><tr class="calibre6">
<td class="calibre7"><span>Sabine Ruschewey,<br class="calibre2"/>
Adelheid Ruschewey,<br class="calibre2"/>
Agathe Ruschewey,<br class="calibre2"/>
Ludowike Ruschewey</span></td>
<td class="calibre8"> </td>
<td class="calibre7">vier Schwestern im Alter von 25, 22, 20 und 15
Jahren, Töchter des verstorbenen Kaufmanns Bertold Ruschewey</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Gustav Ruschewey,<br class="calibre2"/>
Emilie Ruschewey</span></td>
<td class="calibre8"></td>
<td class="calibre7">Geschwister des Bertold Ruschewey; Gustav ist 68,
Emilie 60 Jahre alt</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Oberlehrer Dr.
Nast</span>,</td>
<td class="calibre8"></td>
<td class="calibre7">Pflegesohn Tante Emiliens, 37 Jahre alt</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Frau Madelon von
Heyder</span>,</td>
<td class="calibre8"></td>
<td class="calibre7">Großmama der Schwestern Ruschewey</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Reinhold Kranz</span>,</td>
<td class="calibre8"></td>
<td class="calibre7">Adelheids Bräutigam, Kaufmann, 27 Jahre alt</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Otto Kranz</span>,</td>
<td class="calibre8"></td>
<td class="calibre7">sein Bruder, 17jährig, besucht die Kunstakademie
in München</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Dr. Grünwald</span>,</td>
<td class="calibre8"></td>
<td class="calibre7">Arzt, 34 Jahre alt</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Dr. Kozakiewicz</span>,</td>
<td class="calibre8"></td>
<td class="calibre7">Bibliothekar, 36 Jahre alt, leidend</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Konsistorialrat
Joël</span>,</td>
<td class="calibre8"></td>
<td class="calibre7">70 Jahre alt</td>
</tr>
<tr class="calibre6">
<td class="calibre7"><span>Ein Vagabund</span><br class="calibre2"/>
<span>Ein Herr</span></td>
</tr>
</tbody>
</table>
<p></p>
<p class="calibre5">Die vier Schwestern Ruschewey sind
übereinstimmend gekleidet.</p>
<p class="calibre5">Die Zeit der Geschehnisse ist die zweite Hälfte
des vorigen Jahrhunderts.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?0e5db44c